import { wordsResponse } from '../../../textbook/types';

export enum AudioActionTypes {
  FETCH_AUDIO_WORDS_SUCCESS = 'FETCH_AUDIO_WORDS_SUCCESS',
  FETCH_AUDIO_WORDS = 'FETCH_AUDIO_WORDS',
  UPDATE_GROUP = 'UPDATE_GROUP',
  REMOVE_WORDS = 'REMOVE_WORDS',
  UPDATE_ANSWER = 'UPDATE_ANSWER',
  UPDATE_QUESTION = 'UPDATE_QUESTION',
  UPDATE_WORDS = 'UPDATE_WORDS',
}

interface fetchAudioWordsSucces {
  type: AudioActionTypes.FETCH_AUDIO_WORDS_SUCCESS;
  payload: wordsResponse[];
}

interface fetchAudioWords {
  type: AudioActionTypes.FETCH_AUDIO_WORDS;
}
interface updateGroup {
  type: AudioActionTypes.UPDATE_GROUP;
  payload: number;
}
interface removeWords {
  type: AudioActionTypes.REMOVE_WORDS;
}
interface updateAnswer {
  type: AudioActionTypes.UPDATE_ANSWER;
  payload: string[];
}
interface updateQuestion {
  type: AudioActionTypes.UPDATE_QUESTION;
  payload: number;
}

interface updateWords {
  type: AudioActionTypes.UPDATE_WORDS;
  payload: wordsResponse[];
}
export type AudioAction =
  | fetchAudioWordsSucces
  | updateGroup
  | removeWords
  | updateAnswer
  | updateQuestion
  | fetchAudioWords
  | updateWords;
